import api from './api';
import { User, LoginCredentials } from '../types';

class AuthService {
  async login(credentials: LoginCredentials): Promise<{ user: User; token: string }> {
    try {
      // Fetch CSRF token first
      await api.get('/auth/csrf/');

      console.log('🔐 Login attempt with:', {
        username: credentials.username,
        password: credentials.password,
        passwordLength: credentials.password.length
      });

      const response = await api.post<{ user: User; token: string }>('/auth/login/', credentials);
      console.log('✅ Login successful:', response.data);
      const { user, token } = response.data;

      // Check if user is teacher
      if (user.role !== 'teacher') {
        throw new Error('Accès réservé aux professeurs');
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      return { user, token };
    } catch (error: any) {
      console.error('❌ Login failed:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      throw error;
    }
  }

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout/');
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  }

  async getProfile(): Promise<User> {
    const response = await api.get<User>('/auth/profile/');
    return response.data;
  }

  async updateProfile(data: Partial<User>): Promise<User> {
    const response = await api.patch<User>('/auth/profile/update/', data);
    const updatedUser = response.data;
    // Update localStorage with new user data
    localStorage.setItem('user', JSON.stringify(updatedUser));
    return updatedUser;
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        // Verify it's a teacher
        if (user.role === 'teacher') {
          return user;
        }
      } catch {
        return null;
      }
    }
    return null;
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    const user = this.getCurrentUser();
    return !!(token && user && user.role === 'teacher');
  }
}

const authService = new AuthService();
export default authService;